import * as Actions from '../../actions/settings';


const initialState={
    data: {
        paymentTypes: []
    },
    isLoading: false,
    isLoaded : false,
    error: false
};

const settings = function (state = initialState, action) {
    switch (action.type) {
      
            
        case Actions.GET_SETTINGS: case Actions.SET_SETTINGS:{
            return {
                ...state,
                isLoading: true,
                isLoaded : false,
                error: false
            }
        }
        case Actions.GET_SETTINGS_SUCCESS:   case Actions.SET_SETTINGS_SUCCESS:{

            return {
                ...state,
                data: action.payload,
                isLoading: false,
                isLoaded : true,
                error: false
            }
        }
        case Actions.GET_SETTINGS_ERROR: case Actions.SET_SETTINGS_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded : false,
                error: action.error
            }
        }

        default: {
            return state;
        }
    }
}

export default settings